/**
 * @file     marketing.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for marketing page sections (problem, education, trust, CTA copy, top actions, and pillar descriptions).
 */
export const sections = {
  problem: {
    title: 'Where mistakes usually happen',
    description: 'Most costly mistakes start with a guess made early.'
  },
  education: {
    title: 'How to make a better decision',
    description: 'Use local facts and fair comparisons.'
  },
  trust: {
    title: 'No pressure',
    description: 'You see the trade-offs up front and decide in your own time.'
  },
  marketOpportunity: {
    title: 'Where the openings are',
    description: 'Find homes where you have room to negotiate.'
  }
} as const;

export const ctas = {
  primary: {
    bookConsultation: 'Book a call',
    personalizeSearch: 'Personalize your search',
    activateDealFinder: 'Find your deal',
    getBuyerChecklist: 'Get the buyer checklist',
    getDealAlerts: 'Get deal alerts'
  },
  secondary: {
    readGuide: 'Read the guide',
    compareOptions: 'Compare your options',
    understandMarket: 'See the market',
    exploreNeighborhoods: 'Compare neighbourhoods'
  },
  reassurance: {
    noPressure: 'There is no pressure to commit.'
  }
} as const;

export const topActions = {
  title: 'Choose where to start',
  subtitle: 'Pick buying, selling, or finding tenants.',
  buyers: 'Buy',
  sellers: 'Sell',
  tenants: 'Find tenants'
} as const;

export const pillars = {
  marketClarity: {
    title: 'The market',
    description:
      'See how prices, rates, and supply are moving in each area.'
  },
  decisionClarity: {
    title: 'Your decision',
    description: 'Know what fits your budget and timeline before you commit.'
  },
  processClarity: {
    title: 'The process',
    description: 'Learn each step from search to closing, and where deals go wrong.'
  },
  opportunityClarity: {
    title: 'Openings',
    description: 'Spot homes that may be priced low.'
  }
} as const;
